import React from 'react';
import { ShowIf } from '../../../components/ShowIf';
import { AgreeAcknowledgement } from './components/AgreeAcknowledgement';
import { AgreeTermsheet } from './components/AgreeTermsheet';
import { useShowTermsheet } from '../../hooks/useShowTermsheet';

interface AgreementsParameters {
    set_acknowledgeHtml: React.Dispatch<React.SetStateAction<string | null>>;
    set_termSheetHtml: React.Dispatch<React.SetStateAction<string | null>>;
}

export const Agreements: React.FC<AgreementsParameters> = ({ set_acknowledgeHtml, set_termSheetHtml }) => {
    const checkButtonWidth = '200px';

    const { showTermsheet } = useShowTermsheet();

    return (
        <>
            <h3 style={{ marginTop: 30 }}>Agreements</h3>
            <AgreeAcknowledgement
                set_acknowledgeHtml={set_acknowledgeHtml}
                width={checkButtonWidth}
            />
            <ShowIf showIf={showTermsheet}>
                <AgreeTermsheet
                    set_termSheetHtml={set_termSheetHtml}
                    width={checkButtonWidth}
                />
            </ShowIf>
        </>
    );
};
